import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IOverduePaymentButtonSlice {
  overduePaymentButtonDisabled: boolean;
  overduePaymentButtonOnMobile: boolean;
}

export const createOverduePaymentButtonSliceDefaultValues = (): IOverduePaymentButtonSlice => ({
  overduePaymentButtonDisabled: false,
  overduePaymentButtonOnMobile: false,
});

export const createOverduePaymentButtonSlice: StateCreator<IOverduePaymentButtonSlice> = () =>
  createOverduePaymentButtonSliceDefaultValues();

export type OverduePaymentButtonPageStore = UseBoundStore<StoreApi<IOverduePaymentButtonSlice>>;

export const createOverduePaymentButtonHooks = (pageStore: OverduePaymentButtonPageStore) => {
  return {
    useDisabled: () => pageStore((state) => state.overduePaymentButtonDisabled),
  };
};

export type OverduePaymentButtonHooks = ReturnType<typeof createOverduePaymentButtonHooks>;
